module.exports = __webpack_public_path__ + "img/bay_resort.1d73200a.jpg";